import { Keyword, NumberValue } from '../../values/index.js';
export var JustifyContent;
(function (JustifyContent) {
    JustifyContent["stretch"] = "stretch";
    JustifyContent["flex-start"] = "flex-start";
    JustifyContent["center"] = "center";
    JustifyContent["space-between"] = "space-between";
    JustifyContent["space-evenly"] = "space-evenly";
    JustifyContent["flex-end"] = "flex-end";
})(JustifyContent || (JustifyContent = {}));
export var AlignItems;
(function (AlignItems) {
    AlignItems["stretch"] = "stretch";
    AlignItems["flex-start"] = "flex-start";
    AlignItems["center"] = "center";
    AlignItems["flex-end"] = "flex-end";
})(AlignItems || (AlignItems = {}));
export const Props = (props = {}) => {
    var _a;
    const columnCount = props.columnCount === null ? null : (_a = NumberValue(props.columnCount)) !== null && _a !== void 0 ? _a : 1;
    var weights;
    if (columnCount === null) {
        weights = [];
    }
    else if (!props.weights || !Array.isArray(props.weights) || props.weights.length != props.columnCount) {
        weights = new Array(columnCount).fill(1);
    }
    else {
        weights = props.weights.map((weight) => {
            var _a;
            return (_a = NumberValue(weight)) !== null && _a !== void 0 ? _a : 1;
        });
    }
    return {
        flexWrap: !!props.flexWrap,
        columnCount,
        weights,
        justifyContent: Keyword(props.justifyContent, JustifyContent, columnCount == 1 ? 'flex-start' : 'stretch'),
        alignItems: Keyword(props.alignItems, AlignItems)
    };
};
export const validate = () => true;
export const fix = (props, styles) => props;
export const type = 'layout';
export const property = 'layoutIds';
export const label = 'Layout & Alignment';
export const category = 'aspect';
export const summarize = (props, styles, formId) => { var _a; return `${(_a = props.columnCount) !== null && _a !== void 0 ? _a : 'Auto'}`; };
//# sourceMappingURL=layout.js.map